const M = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTMgMzQyIj48cGF0aCBmaWxsPSIjZDUyYjFlIiBkPSJNMCAwaDUxM3YxMTRIMHoiLz48cGF0aCBmaWxsPSIjZjllMzAwIiBkPSJNMCAxMTRoNTEzdjExNEgweiIvPjxwYXRoIGZpbGw9IiMwMDc5MzQiIGQ9Ik0wIDIyOGg1MTN2MTE0SDB6Ii8+PC9zdmc+Cg==";
export {
  M as default
};
//# sourceMappingURL=BO-25308a0a.mjs.map
